import { Injectable }       from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
}                           from '@angular/router';
import { UserService }      from '@app/core/services/user.service';
import { environment }      from '@env/environment';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }

  // Check the login creditials to make sure they are valid
  // otherwise send them back to the login screen
  checkLogin(url: string): boolean {

    if (!this.userService.isLoggedIn()) {
      this.userService.redirectUrl = url;

      this.router.navigate(['/login']);
      // for debug only
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/auth-guard.service.ts